import styled from "styled-components";

const FlagContainerPassportPreview = styled.div`
  position: absolute;
  height: 18px;
  width: 31px;
  border-radius: 4px;
  overflow: hidden;
`;

export default FlagContainerPassportPreview;
